import { render, staticRenderFns } from "./network-indicator.vue?vue&type=template&id=06564786&scoped=true"
import script from "./network-indicator.vue?vue&type=script&lang=ts"
export * from "./network-indicator.vue?vue&type=script&lang=ts"
import style0 from "./network-indicator.vue?vue&type=style&index=0&id=06564786&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06564786",
  null
  
)

export default component.exports